// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DepartmentList-module__departmentList__ULDl6 {
  min-width: calc(50% - 18px);
  margin-top: 2rem;
}

.DepartmentList-module__title__UoTww {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: #333;
}

.DepartmentList-module__selectWrapper__AI3yS {
  margin-bottom: 1.5rem;
}

.DepartmentList-module__label__zjVkA {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: #555;
  margin-bottom: 0.5rem;
}

.DepartmentList-module__select__d0n1q {
  width: 100%;
  max-width: 320px;
  padding: 0.625rem 0.875rem;
  font-size: 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fff;
  color: #333;
  cursor: pointer;
}

.DepartmentList-module__select__d0n1q:focus {
  outline: none;
  border-color: #4a90d9;
  box-shadow: 0 0 0 2px rgba(74, 144, 217, 0.2);
}

.DepartmentList-module__content__zMCns {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 1.25rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.DepartmentList-module__branchInfo__iaOCc {
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #f0f0f0;
}

.DepartmentList-module__branchName__KxhLz {
  font-size: 1.125rem;
  font-weight: 600;
  color: #333;
  margin: 0 0 0.25rem 0;
}

.DepartmentList-module__institution__dLytI {
  font-size: 0.875rem;
  color: #666;
}

.DepartmentList-module__list__lmxEz {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.DepartmentList-module__departmentItem__eSm9t {
  padding: 0.875rem;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #eee;
}

.DepartmentList-module__departmentName__EFFpj {
  font-weight: 600;
  color: #2d3748;
  font-size: 1rem;
}

.DepartmentList-module__departmentDescription__cBGr3 {
  font-size: 0.875rem;
  color: #718096;
  margin-top: 0.25rem;
}

.DepartmentList-module__loading__U4JrG,
.DepartmentList-module__error__nQjDd,
.DepartmentList-module__empty__zL5Np,
.DepartmentList-module__hint__lVaGV {
  padding: 1rem 0;
  font-size: 0.9375rem;
  color: #666;
}

.DepartmentList-module__error__nQjDd {
  color: #d32f2f;
  background: #ffebee;
  padding: 1rem;
  border-radius: 6px;
}

.DepartmentList-module__empty__zL5Np,
.DepartmentList-module__hint__lVaGV {
  color: #718096;
}
`, "",{"version":3,"sources":["webpack://./src/components/DepartmentList/DepartmentList.module.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;EAIE,eAAe;EACf,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB","sourcesContent":[".departmentList {\n  min-width: calc(50% - 18px);\n  margin-top: 2rem;\n}\n\n.title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n  color: #333;\n}\n\n.selectWrapper {\n  margin-bottom: 1.5rem;\n}\n\n.label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #555;\n  margin-bottom: 0.5rem;\n}\n\n.select {\n  width: 100%;\n  max-width: 320px;\n  padding: 0.625rem 0.875rem;\n  font-size: 1rem;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background: #fff;\n  color: #333;\n  cursor: pointer;\n}\n\n.select:focus {\n  outline: none;\n  border-color: #4a90d9;\n  box-shadow: 0 0 0 2px rgba(74, 144, 217, 0.2);\n}\n\n.content {\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 1.25rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n}\n\n.branchInfo {\n  margin-bottom: 1rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.branchName {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #333;\n  margin: 0 0 0.25rem 0;\n}\n\n.institution {\n  font-size: 0.875rem;\n  color: #666;\n}\n\n.list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.departmentItem {\n  padding: 0.875rem;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border: 1px solid #eee;\n}\n\n.departmentName {\n  font-weight: 600;\n  color: #2d3748;\n  font-size: 1rem;\n}\n\n.departmentDescription {\n  font-size: 0.875rem;\n  color: #718096;\n  margin-top: 0.25rem;\n}\n\n.loading,\n.error,\n.empty,\n.hint {\n  padding: 1rem 0;\n  font-size: 0.9375rem;\n  color: #666;\n}\n\n.error {\n  color: #d32f2f;\n  background: #ffebee;\n  padding: 1rem;\n  border-radius: 6px;\n}\n\n.empty,\n.hint {\n  color: #718096;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"departmentList": `DepartmentList-module__departmentList__ULDl6`,
	"title": `DepartmentList-module__title__UoTww`,
	"selectWrapper": `DepartmentList-module__selectWrapper__AI3yS`,
	"label": `DepartmentList-module__label__zjVkA`,
	"select": `DepartmentList-module__select__d0n1q`,
	"content": `DepartmentList-module__content__zMCns`,
	"branchInfo": `DepartmentList-module__branchInfo__iaOCc`,
	"branchName": `DepartmentList-module__branchName__KxhLz`,
	"institution": `DepartmentList-module__institution__dLytI`,
	"list": `DepartmentList-module__list__lmxEz`,
	"departmentItem": `DepartmentList-module__departmentItem__eSm9t`,
	"departmentName": `DepartmentList-module__departmentName__EFFpj`,
	"departmentDescription": `DepartmentList-module__departmentDescription__cBGr3`,
	"loading": `DepartmentList-module__loading__U4JrG`,
	"error": `DepartmentList-module__error__nQjDd`,
	"empty": `DepartmentList-module__empty__zL5Np`,
	"hint": `DepartmentList-module__hint__lVaGV`
};
export default ___CSS_LOADER_EXPORT___;
